import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service'
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {

  adventure;
  citysStatus : any[];
  displayedColumns: string[] = ['name', 'status'];
  constructor(private dashboardService : DashboardService, private httpClient: HttpClient) { }
  listStatus = [
    { "id" : 1, "text" : "Started" },
    { "id" : 2, "text" : "Finished" },
    { "id" : 3, "text" : "Mail sent" },
    { "id" : 4, "text" : "PostCard Prepared" },
    { "id" : 5, "text" : "PostCard Sent" }
  ]
  

  ngOnInit(): void {
    this.getCityStatus();
  }

  async getCityStatus(){
    this.citysStatus = await this.dashboardService.getCityStatus().toPromise();
  }

}
